<template>
    <div class="order-card-container" v-show="startAnimitionShapeFive">
        <div class="order-card" v-if="showOrderCard" :class="{ 'appear': showOrderCard, 'hide': hideOrderCard }">
            <!-- Order Status Row -->
            <div class="status-row">
                <div class="status-icon">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="5.93602" cy="5.99998" r="5.61326" fill="#43A047" fill-opacity="0.27" />
                        <circle cx="5.92304" cy="5.98682" r="2.89032" fill="#43A047" />
                    </svg>
                </div>
                <span class="status-text">اكتمل الطلب</span>
            </div>

            <!-- Order Number -->
            <div class="order-number">923125280</div>

            <!-- Order Details -->
            <div class="order-details">
                <!-- URL Row -->
                <div class="detail-row">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.6294 13.2434H5.89799C5.86256 13.2364 5.82714 13.2279 5.79171 13.2224C5.4512 13.1695 5.1052 13.1411 4.7711 13.061C1.56756 12.2932 -0.496261 9.07304 0.130704 5.83119C0.391201 4.48343 1.02061 3.33457 2.03389 2.41152C3.47961 1.09461 5.18796 0.56938 7.12352 0.815345C8.35638 0.97209 9.44295 1.47838 10.3744 2.30152C11.4714 3.27102 12.1579 4.47732 12.4101 5.92377C12.451 6.15843 12.4746 6.39615 12.506 6.63234V7.36412C12.4984 7.4072 12.4895 7.44998 12.4837 7.49336C12.4541 7.71855 12.4364 7.94618 12.3942 8.16923C12.1582 9.41342 11.592 10.488 10.7024 11.3866C9.76972 12.3289 8.64894 12.922 7.33943 13.1478C7.10428 13.1884 6.86607 13.2117 6.6294 13.2434ZM3.78652 4.64415C3.63291 5.29557 3.54496 5.95494 3.53 6.62225H5.89127V4.79142C5.18979 4.74253 4.49503 4.69364 3.78652 4.64415ZM6.6352 6.62439H8.99861C8.98029 5.95463 8.8963 5.30229 8.74422 4.66095C8.03755 4.70556 7.33912 4.74956 6.6352 4.79386V6.62439ZM2.7598 6.62683C2.84989 5.91522 2.93785 5.22041 3.02702 4.51765C3.02305 4.51673 3.00045 4.51062 2.97724 4.50512C2.53137 4.39971 2.08459 4.29857 1.64086 4.18552C1.5526 4.16322 1.52145 4.18552 1.48144 4.2561C1.20171 4.7465 0.9974 5.26593 0.883184 5.81836C0.828519 6.08205 0.797675 6.35093 0.754615 6.62653L2.7598 6.62683ZM11.0178 9.78557C11.4512 9.04554 11.7007 8.24226 11.7578 7.37206H9.76544C9.67596 8.06474 9.58801 8.74672 9.50006 9.429C9.98685 9.54327 10.4944 9.66274 11.0178 9.78557ZM11.0191 4.21363C10.4984 4.32974 9.99326 4.44218 9.50617 4.55095C9.59259 5.23843 9.67933 5.92836 9.76667 6.62378H11.7584C11.6992 5.7542 11.4524 4.95275 11.0191 4.21363ZM6.63612 7.37084V9.16776C7.34034 9.21634 8.03786 9.26431 8.74025 9.31259C8.89234 8.67583 8.97632 8.03143 8.998 7.37084H6.63612ZM3.78469 9.29823C4.49472 9.25392 5.19315 9.21023 5.88791 9.16684V7.37023H3.53C3.55168 8.02654 3.63291 8.66727 3.78469 9.29823ZM2.76316 7.37053H0.781184C0.777825 7.38703 0.773244 7.39864 0.773855 7.40964C0.828825 8.22851 1.06306 8.9936 1.46831 9.70613C1.48389 9.73363 1.55626 9.74829 1.59566 9.73943C1.9832 9.65327 2.3689 9.56008 2.75553 9.47117C2.85203 9.44886 2.95067 9.43511 3.02488 9.42167C2.93632 8.72777 2.8505 8.05374 2.76316 7.37053ZM6.63612 4.05444C7.2698 4.01686 7.89524 3.97958 8.53717 3.94139C8.50296 3.84789 8.47914 3.78006 8.45349 3.71315C8.2217 3.11 7.93127 2.54138 7.47441 2.07328C7.23957 1.83251 6.97327 1.63879 6.63612 1.54377V4.05444ZM3.99113 10.0181C4.26324 10.7645 4.58634 11.4499 5.1623 11.9846C5.37241 12.1795 5.60909 12.3308 5.89096 12.4096V9.90504C5.26064 9.94262 4.63826 9.9796 3.99113 10.0181ZM5.89066 4.052V1.54316C5.64329 1.61374 5.43563 1.73687 5.24812 1.89453C4.72376 2.33574 4.40555 2.91659 4.14383 3.53471C4.09252 3.65601 4.04977 3.78098 3.99449 3.92611C4.63978 3.96889 5.26186 4.01044 5.89066 4.052ZM6.63459 12.4285C7.71842 11.9809 8.13344 11.0325 8.54083 10.0312C7.89005 9.98876 7.26552 9.94782 6.63459 9.90657V12.4285ZM1.9435 10.3933C2.30844 11.0047 3.8247 12.1172 4.27362 12.1074C3.8021 11.5147 3.49335 10.8431 3.25118 10.1198C2.81447 10.2112 2.38662 10.3007 1.9435 10.3933ZM10.5778 10.4257C10.1231 10.3258 9.69795 10.2326 9.26949 10.1388C9.02945 10.8611 8.71612 11.5232 8.26537 12.1187C9.18429 11.7728 9.93952 11.2097 10.5778 10.4257ZM8.29683 1.88537C8.73659 2.47354 9.04411 3.12802 9.27774 3.84056C9.70681 3.75103 10.1295 3.66304 10.5772 3.56984C9.94959 2.7959 9.20261 2.23827 8.29683 1.88537ZM4.21896 1.87712C3.33852 2.23216 2.59947 2.78062 1.97678 3.53623C2.41532 3.63309 2.83249 3.72506 3.23713 3.81428C3.38646 3.46565 3.51045 3.13047 3.67109 2.81392C3.83386 2.4934 4.03328 2.19122 4.21896 1.87712Z"
                            fill="#5854FF" />
                    </svg>
                    <span class="detail-text">https://akwad.sa/</span>
                </div>

                <!-- Price Row -->
                <div class="detail-row">

                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.61143 11.9035C9.40265 11.9035 9.1935 11.9061 8.98472 11.9028C8.80751 11.9002 8.66003 11.96 8.53409 12.0844C8.2993 12.3159 8.0608 12.5436 7.8249 12.7739C7.18369 13.3995 6.32925 13.4006 5.69101 12.7761C5.46217 12.5521 5.2285 12.3326 5.00225 12.106C4.86257 11.9659 4.70246 11.8991 4.50407 11.902C4.11883 11.9076 3.73322 11.905 3.34797 11.9035C2.48387 11.9002 1.85603 11.2727 1.85306 10.409C1.85158 10.019 1.85009 9.62891 1.85381 9.23885C1.85566 9.05125 1.79214 8.89745 1.66025 8.76446C1.4277 8.53079 1.20071 8.29155 0.970754 8.05566C0.359267 7.42785 0.36001 6.57157 0.972983 5.94227C1.20628 5.70266 1.43736 5.46119 1.67177 5.2227C1.79548 5.09677 1.85492 4.94891 1.85381 4.77171C1.85083 4.38648 1.85269 4.00088 1.85306 3.61565C1.85418 2.71627 2.47606 2.09738 3.37918 2.09626C3.75996 2.09589 4.14075 2.09366 4.52154 2.09738C4.70394 2.09923 4.85514 2.03868 4.98479 1.91089C5.22627 1.67314 5.46997 1.43762 5.71405 1.20246C6.3337 0.605113 7.18778 0.608084 7.80744 1.20878C8.04743 1.44133 8.2889 1.6724 8.52629 1.90792C8.65557 2.03608 8.80566 2.09886 8.98806 2.09738C9.38259 2.09441 9.7775 2.09478 10.172 2.09663C11.028 2.10072 11.6554 2.72779 11.6599 3.58407C11.6621 3.97859 11.6628 4.37348 11.6591 4.768C11.6576 4.95077 11.7204 5.10085 11.8482 5.23013C12.0834 5.46788 12.3148 5.70898 12.5474 5.94896C13.1518 6.57306 13.1511 7.4271 12.5452 8.05306C12.3126 8.29341 12.0808 8.53414 11.846 8.77189C11.7182 8.90154 11.6573 9.05236 11.6591 9.23476C11.6628 9.62482 11.6614 10.0149 11.6599 10.4049C11.6565 11.2772 11.0298 11.9006 10.1546 11.9035C9.97365 11.9043 9.79235 11.9035 9.61143 11.9035ZM10.7687 4.21931C10.7687 4.00571 10.7701 3.7921 10.7687 3.57887C10.7657 3.22113 10.5328 2.98932 10.1728 2.9882C9.7827 2.98672 9.39299 2.98523 9.00292 2.98857C8.57235 2.99229 8.20606 2.84407 7.89994 2.54205C7.66218 2.30727 7.4222 2.07472 7.18109 1.84291C6.91064 1.58287 6.60118 1.58361 6.33148 1.84439C6.09446 2.07323 5.8567 2.3017 5.62303 2.53387C5.31023 2.84481 4.9365 2.99489 4.49516 2.98895C4.10992 2.98375 3.72467 2.98672 3.33943 2.9882C2.97982 2.98969 2.74652 3.22187 2.74503 3.58035C2.74354 3.97042 2.74131 4.36011 2.7454 4.75017C2.74986 5.18072 2.60349 5.54775 2.30183 5.8546C2.0741 6.08641 1.84823 6.32007 1.62199 6.55299C1.33445 6.84907 1.33296 7.14886 1.6179 7.44271C1.85046 7.68269 2.08413 7.92193 2.31669 8.16154C2.60535 8.4591 2.74689 8.81535 2.74503 9.22993C2.74317 9.62445 2.74354 10.019 2.74503 10.4135C2.74614 10.7801 2.97833 11.0105 3.3476 11.0116C3.73284 11.0127 4.11809 11.0157 4.50333 11.0108C4.93947 11.0053 5.30948 11.1546 5.61857 11.4615C5.85261 11.6936 6.09037 11.9217 6.32702 12.1509C6.60267 12.4177 6.9099 12.418 7.18667 12.1509C7.4274 11.9188 7.66701 11.6862 7.90551 11.4518C8.20866 11.1539 8.57124 11.0075 8.99661 11.0108C9.38668 11.0138 9.77638 11.0123 10.1665 11.0108C10.5346 11.0097 10.7668 10.7787 10.7683 10.4116C10.7698 10.0216 10.7713 9.63188 10.7683 9.24182C10.7646 8.81647 10.9091 8.45353 11.2074 8.15002C11.4385 7.91487 11.6677 7.67823 11.8969 7.44122C12.177 7.15146 12.1785 6.84833 11.9006 6.56042C11.6684 6.32007 11.4351 6.08046 11.2018 5.8416C10.9083 5.54106 10.7642 5.18146 10.7687 4.76131C10.7705 4.5804 10.7687 4.39911 10.7687 4.2182V4.21931Z"
                            fill="#5854FF" />
                        <path
                            d="M4.04226 10.1196C3.91038 10.1144 3.7733 10.0402 3.69008 9.88264C3.60686 9.72513 3.61875 9.56948 3.71757 9.42163C3.7406 9.38745 3.7707 9.35736 3.80004 9.32801C5.55983 7.5679 7.31999 5.80817 9.07904 4.04732C9.20275 3.92362 9.34169 3.85563 9.51629 3.88869C9.84098 3.95073 9.98512 4.33374 9.78414 4.59638C9.75331 4.63687 9.71541 4.67179 9.67938 4.7082C7.93928 6.44861 6.19844 8.18829 4.45908 9.92945C4.35395 10.0346 4.24324 10.12 4.04189 10.12L4.04226 10.1196Z"
                            fill="#5854FF" />
                        <path
                            d="M4.97263 3.88037C5.70819 3.88 6.31002 4.48069 6.31039 5.21587C6.31076 5.95104 5.70968 6.55359 4.97486 6.55396C4.24003 6.55471 3.63709 5.95253 3.63672 5.2181C3.63635 4.48329 4.2378 3.88074 4.97263 3.88037ZM4.97783 5.66277C5.21967 5.66054 5.41917 5.45882 5.4188 5.21661C5.41843 4.97477 5.21782 4.77343 4.97597 4.77194C4.72669 4.77045 4.52423 4.97552 4.52832 5.22478C4.53203 5.46625 4.73598 5.665 4.97783 5.66277Z"
                            fill="#5854FF" />
                        <path
                            d="M8.53472 7.44623C9.27066 7.44437 9.87397 8.04321 9.8762 8.77838C9.87843 9.5143 9.27883 10.118 8.544 10.1202C7.80881 10.1224 7.20438 9.5221 7.20215 8.78767C7.2003 8.05213 7.79989 7.44809 8.53435 7.44623H8.53472ZM8.53397 8.3378C8.29064 8.3404 8.09338 8.54063 8.09412 8.78433C8.09486 9.02617 8.29547 9.22751 8.53732 9.22863C8.78474 9.22974 8.98906 9.02245 8.9846 8.77467C8.98014 8.5332 8.77582 8.3352 8.53397 8.3378Z"
                            fill="#5854FF" />
                    </svg>
                    <span class="detail-text">1200</span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_312_924)">
                            <path
                                d="M7.15176 10.0155C6.94749 10.3839 6.81247 10.7837 6.76074 11.203L11.0834 10.4555C11.2877 10.0872 11.4226 9.68733 11.4744 9.26807L7.15176 10.0155Z"
                                fill="#231F20" />
                            <path
                                d="M11.0841 8.21652C11.2884 7.84819 11.4234 7.4483 11.4752 7.02904L8.10792 7.61155V6.49174L11.084 5.97731C11.2883 5.60898 11.4233 5.20909 11.4751 4.78983L8.10782 5.37185V1.34467C7.59186 1.58031 7.13364 1.89397 6.76115 2.26396V5.60476L5.41449 5.83758V0.796936C4.89853 1.03249 4.4403 1.34624 4.06782 1.71623V6.07032L1.05464 6.59113C0.850374 6.95946 0.715249 7.35935 0.663418 7.77862L4.06782 7.19013V8.60034L0.419338 9.23097C0.215072 9.5993 0.0800487 9.99919 0.0283203 10.4185L3.84726 9.75833C4.15814 9.70573 4.42533 9.55623 4.59905 9.35049L5.29942 8.50591C5.37213 8.41853 5.41449 8.31301 5.41449 8.19954V6.95731L6.76115 6.72448V8.96411L11.0841 8.21652Z"
                                fill="#231F20" />
                        </g>
                        <defs>
                            <clipPath id="clip0_312_924">
                                <rect width="11.4468" height="10.4062" fill="white"
                                    transform="translate(0.0283203 0.796875)" />
                            </clipPath>
                        </defs>
                    </svg>

                </div>

                <!-- Notes Row -->
                <div class="detail-row">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.553198 6.23195C0.553198 4.61246 0.551779 2.99297 0.553907 1.37349C0.554617 0.685108 0.999835 0.146211 1.66819 0.0222261C1.77178 0.00301714 1.87998 0.000921064 1.98606 0.000921064C4.69958 -0.000126697 7.41346 -0.000476291 10.127 0.000571469C10.8461 0.000571469 11.385 0.4085 11.5283 1.06335C11.5542 1.18175 11.5602 1.30608 11.5602 1.42762C11.5627 2.55816 11.562 3.68904 11.5609 4.81957C11.5609 4.88453 11.5584 4.95159 11.5432 5.01411C11.5006 5.18943 11.32 5.31272 11.1448 5.29421C10.9596 5.27465 10.8142 5.1325 10.7989 4.95264C10.7943 4.9006 10.7961 4.84786 10.7961 4.79547C10.7961 3.67367 10.7961 2.55152 10.7961 1.42972C10.7961 0.980577 10.5644 0.751118 10.1096 0.751118C7.40921 0.751118 4.70881 0.751118 2.00841 0.751118C1.54758 0.751118 1.31982 0.973592 1.31982 1.42413C1.31982 4.63691 1.31982 7.85004 1.31982 11.0628C1.31982 11.512 1.54864 11.7348 2.00911 11.7351C2.73636 11.7355 3.46361 11.7348 4.19086 11.7362C4.2611 11.7362 4.33454 11.7372 4.40123 11.7561C4.57258 11.805 4.67688 11.9723 4.65843 12.1525C4.64105 12.3236 4.50695 12.4595 4.3317 12.4811C4.29658 12.4853 4.26075 12.486 4.22563 12.486C3.46752 12.486 2.70905 12.4895 1.95093 12.4853C1.22936 12.4815 0.689069 12.0365 0.569872 11.352C0.552843 11.2539 0.553907 11.1522 0.553907 11.052C0.552843 9.44543 0.553198 7.83922 0.553198 6.23265V6.23195Z"
                            fill="#5854FF" />
                        <path
                            d="M11.9999 7.59409C11.9949 8.02611 11.8346 8.36733 11.5405 8.65477C10.9555 9.2265 10.3737 9.80207 9.79083 10.3759C9.28637 10.8725 8.76985 11.3583 8.2817 11.8707C8.01776 12.148 7.7219 12.308 7.34054 12.3446C7.08121 12.3694 6.82472 12.425 6.56752 12.4693C5.98182 12.5702 5.54441 12.1365 5.64941 11.5609C5.71114 11.2221 5.7679 10.8823 5.8236 10.5421C5.8534 10.3595 5.93109 10.2048 6.06483 10.0731C7.22559 8.93243 8.38316 7.78862 9.54534 6.64936C9.95757 6.24527 10.4542 6.11116 11.0094 6.28683C11.5646 6.46251 11.8846 6.85611 11.9843 7.42121C11.9956 7.48547 11.996 7.55113 11.9995 7.59444L11.9999 7.59409ZM9.11928 8.14416C9.10367 8.15499 9.09161 8.16093 9.08239 8.17001C8.26716 8.97189 7.45193 9.77343 6.63883 10.5771C6.6069 10.6085 6.58171 10.6563 6.57391 10.7003C6.51786 11.0091 6.46642 11.3189 6.41498 11.6287C6.40895 11.6643 6.41427 11.7013 6.41427 11.7429C6.75802 11.6811 7.08937 11.6245 7.41893 11.5592C7.4835 11.5462 7.55374 11.5127 7.59986 11.4673C8.39168 10.692 9.1803 9.91348 9.96927 9.13534C9.99624 9.1088 10.0207 9.08051 10.0399 9.0599C9.73017 8.75186 9.42827 8.45185 9.11893 8.14416H9.11928ZM10.6 8.48748C10.7547 8.34184 10.9285 8.19795 11.0779 8.03275C11.2978 7.78932 11.2844 7.42505 11.0662 7.18406C10.854 6.94972 10.478 6.88685 10.2229 7.07579C10.0211 7.22527 9.84937 7.41492 9.67518 7.57697C9.99659 7.89375 10.3024 8.19445 10.6 8.48783V8.48748Z"
                            fill="#5854FF" />
                        <path
                            d="M6.05155 3.04653C5.1345 3.04653 4.2171 3.04758 3.30006 3.04583C3.07834 3.04549 2.91444 2.89216 2.9038 2.68506C2.89351 2.48458 3.05031 2.3152 3.26991 2.29319C3.31815 2.2883 3.36711 2.29005 3.41607 2.29005C5.09974 2.29005 6.78341 2.29005 8.46743 2.29005C8.57386 2.29005 8.68029 2.2883 8.78636 2.2904C9.04391 2.29599 9.21242 2.4535 9.20674 2.68086C9.20107 2.90054 9.03114 3.04583 8.77713 3.04583C7.86896 3.04618 6.96043 3.04583 6.05226 3.04583L6.05155 3.04653Z"
                            fill="#5854FF" />
                        <path
                            d="M6.04829 5.17245C5.1355 5.17245 4.22307 5.1728 3.31028 5.1721C3.12226 5.1721 2.98284 5.07885 2.9275 4.92448C2.87322 4.7736 2.90941 4.60107 3.04528 4.51515C3.13255 4.45997 3.2482 4.42784 3.35285 4.4226C3.6136 4.40968 3.87541 4.41841 4.13686 4.41841C5.65628 4.41841 7.17606 4.41841 8.69548 4.41841C8.75295 4.41841 8.81113 4.41876 8.86753 4.42644C9.08145 4.45543 9.21803 4.61853 9.20491 4.82494C9.19249 5.01913 9.03356 5.17 8.82532 5.17105C8.28502 5.1742 7.74438 5.1721 7.20373 5.17245C6.81846 5.17245 6.43284 5.17245 6.04758 5.17245H6.04829Z"
                            fill="#5854FF" />
                        <path
                            d="M4.669 7.29855C4.20817 7.29855 3.74698 7.30135 3.28616 7.29716C3.08536 7.29541 2.93956 7.16514 2.90799 6.97689C2.88032 6.81274 2.97787 6.64161 3.14284 6.57909C3.19498 6.55918 3.25494 6.5501 3.31134 6.5501C4.22449 6.54836 5.13763 6.54766 6.05077 6.54975C6.24588 6.5501 6.3775 6.63986 6.43532 6.79563C6.48889 6.94022 6.45874 7.11031 6.32996 7.19692C6.24482 7.2542 6.12881 7.29227 6.02558 7.29471C5.57362 7.30519 5.12131 7.29925 4.66935 7.29925L4.669 7.29855Z"
                            fill="#5854FF" />
                    </svg>
                    <span class="detail-text">22 ملاحظة</span>
                </div>
            </div>

            <!-- Receive Order Button -->
            <button class="receive-button" aria-hidden="true" tabindex="-1">
                <span>استلام الطلب</span>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
const props = defineProps({
    startAnimitionShapeFive: {
        type: Boolean,
        required: true
    }
})
const startAnimationRun = ref(false)

const startAnimitionShapeFive = computed(() => props.startAnimitionShapeFive)
watch(startAnimitionShapeFive, (newVal) => {
    if (newVal) {
        startAnimationSequence()
    } else {
        startAnimationRun.value = false
    }
})
const hideOrderCard = ref(true)
const showOrderCard = ref(false)
const startAnimationSequence = async () => {
    if(!startAnimitionShapeFive.value || startAnimationRun.value){
        return
    }
    startAnimationRun.value = true
    showOrderCard.value = true
    hideOrderCard.value = false
    await new Promise(resolve => setTimeout(resolve, 800))

    await new Promise(resolve => setTimeout(resolve, 3000))
    hideOrderCard.value = true
    showOrderCard.value = false
    await new Promise(resolve => setTimeout(resolve, 1000))

    startAnimationSequence()
}

onMounted(() => {
    startAnimationSequence()
})


</script>

<style scoped>
@keyframes orderCardAppear {
    0% {
        opacity: 0;
        transform: scale(0.8) translateY(20px);
    }

    50% {
        opacity: 0.8;
        transform: scale(1.05) translateY(-5px);
    }

    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

@keyframes orderCardHide {
    0% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }

    100% {
        opacity: 0;
        transform: scale(0.8) translateY(-20px);
    }
}

.order-card-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 340px;
    height: 340px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-card {
    position: relative;
    border-radius: 11.88px;
    padding: 14px;
    /* display: flex;
    flex-direction: column; */
    gap: 9px;
    border: 1px solid rgba(238, 238, 238, 0.933333);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 191px;
    background: white;
    >div {
        margin-block: 10px;
    }
}

.order-card.appear {
    opacity: 1;
    animation: orderCardAppear 0.8s ease-out;
}

.order-card.hide {
    animation: orderCardHide 0.5s ease-in forwards;
}

.status-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 2.70968px;
    gap: 3.61px;
    width: 66.26px;
    height: 14px;
    background: rgba(243, 244, 246, 0.933333);
    border-radius: 7.22581px;
    align-self: flex-end;
}

.status-text {
    width: 46px;
    height: 14px;
    font-style: normal;
    font-weight: 400;
    font-size: 9.35544px;
    line-height: 14px;
    text-align: center;
    color: #161616;
}

.status-icon {
    width: 11.23px;
    height: 11.23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.order-number {
    width: 100px;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-align: start;
    color: #000000;
    align-self: flex-end;
}

.order-details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 9px;
    width: 100px;
    height: 66px;
    align-self: flex-end;
}

.detail-row {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding: 0px;
    gap: 4.02px;
    width: 100px;
    height: 16px;
}

.detail-text {
    font-style: normal;
    font-weight: 400;
    font-size: 10.4062px;
    line-height: 16px;
    color: #161616;
    direction: rtl;
}

.receive-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2.73205px 4.09807px;
    gap: 4.1px;
    width: 165px;
    height: 24px;
    background: #1A0F91;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    align-self: center;
    margin-top: auto;
}

.receive-button span {
    width: 64px;
    height: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 9px;
    text-align: center;
    color: #FFFFFF;
}
</style>